import { render } from "./BaomaPayment.vue?vue&type=template&id=ddcf8650&scoped=true"
import script from "./BaomaPayment.vue?vue&type=script&lang=js"
export * from "./BaomaPayment.vue?vue&type=script&lang=js"

import "./BaomaPayment.vue?vue&type=style&index=0&id=ddcf8650&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddcf8650"]])

export default __exports__